import script from "./LtActions.vue?vue&type=script&setup=true&lang=js"
export * from "./LtActions.vue?vue&type=script&setup=true&lang=js"

import "./LtActions.vue?vue&type=style&index=0&id=4ec6d98f&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ec6d98f"]])

export default __exports__